<template>
  <div>

    <div>
      <div class="d-flex align-items-center flex-wrap">
        <div class="pr-1 w-20">
          <AppSearchInput
            :value="filter.search"
            :label="$t('search') + ':'"
            :placeholder="$t('search') + '...'"
            @callback="search"
          />
        </div>

        <div class="px-1 w-20">
          <b-form-group :label="$t('dateFromTo') + ':'">
            <VueDataPicker
            class="dark-mod"
              v-model="dateFilter"
              :other-props="{ 'is-range': true }"
              @input="dateInput"
            />
          </b-form-group>
        </div>


        <div class="px-1 w-20">
          <b-form-group :label="$t('filter_by_supplier') + ':'">
            <v-select
              v-model="filter.seller"
              class="bg-white rounded"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="company_name"
              :options="contects"
              :reduce="(el) => el.id"
              @input="onFiltered"
            />
          </b-form-group>
        </div>

        <div class="px-1 w-20">
        
          <b-form-group :label="$t('filter_by_status') + ':'">
            <v-select
              v-model="filter.status"
              class="bg-white rounded"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="[
                ...GET_APPLICATION_STATUS.results,
                { id: 'all', name: $t('all') }
              ]"
              :reduce="(el) => el.id"
              @input="onFiltered"
            />
          </b-form-group>
        </div>


        <div class="px-1 w-20">
          <b-form-checkbox
            v-model="filter.is_old"
            name="check-button"
            @input="onFiltered"
            switch
            inline
          >
            {{$t('archive')}}
          </b-form-checkbox>
        </div>


        <div class="w-20 mb-1">
          <b-button
            v-if="checkButtonPermission(['supplier', 'chief_supplier', 'admin'])"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="mt-1 w-100"
            variant="primary"
            @click="$router.push('/add-agreements/new/') && disableButton"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            />
            {{ $t('add_agreement')}}
          </b-button>
        </div>
      </div>

    </div>





    <b-table
      v-if="!isLoading"
      id="user-table"
      class="mt-1 px-2 rounded bg-light-secondary dark"
      :fields="fields"
      :items="GET_CONTRACTS_LIST.results"
      show-empty
      responsive
      :tbody-tr-class="['tableRowClass']"
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>
      <template #cell(created_at)="{ value }">
        <span class="font-weight-bold">
          {{ $dayjs(value).format("DD.MM.YYYY") }}
        </span>
      </template>
      <template #cell(contract_number)="{ value }">
        <span class="font-weight-bold">
          {{ value }}
        </span>
      </template>
      <template #cell(status)="{ value }">
        <b-badge :variant="value.color">
          {{ value.name }}
        </b-badge>
      </template>
      <template #cell(amount)="{ value }">
        {{ $_formatPriceMixin(value) }}
      </template>
      <template #cell(instruments_goods)="{ value }">
        <div v-for="(item, index) in value" :key="index" class="text-center">
          <b-badge v-if="index < 5" variant="success" class="mb-25">
            {{ item }}
          </b-badge>
          <b-badge v-else-if="index == 5" variant="success" class="mb-25 cursor-pointer" @click="openSeeProductsModal(value)"> ... </b-badge>
        </div>
      </template>
      <template #cell(actions)="props">
        <div class="d-flex align-items-center justify-content-center">
          <b-button
            variant="primary"
            size="sm"
            class="mt-50 mb-50"
            @click="$router.push(`/view-agreements/${props.item.id}/`)"
          >
            <feather-icon icon="ChevronsRightIcon" size="18" />
          </b-button>

          <b-button
            variant="warning"
            size="sm"
            class="ml-50 mt-50 mb-50"
            v-if="props.item.status.is_editable"
            @click="$router.push(`/edit-agreements/${props.item.id}/`)"
          >
            <feather-icon icon="EditIcon" size="18" />
          </b-button>

          <!-- <b-button
            variant="danger"
            size="sm"
            class="ml-50"
            @click="deleteContract(props.item.id)"
          >
            <feather-icon
              icon="Trash2Icon"
              size="18"
            />
          </b-button> -->

          <!-- <template
            v-if="props && props.item && props.item.status"
          >
            <template
              v-for="(item, index) in props.item.status.change_to"
            >
              <b-button
                :key="index"
                v-b-tooltip.hover="{ variant: item.color }"
                size="sm"
                class="ml-50"
                :variant="item.color"
                @click="onChangeStatus(props, item)"
              >
                <feather-icon
                  :icon="item.icon"
                  size="18"
                />
              </b-button>
            </template>
          </template> -->
        </div>
      </template>
    </b-table>

    <b-card v-else>
      <Loader />
    </b-card>

    <Pagination
      :rows="GET_CONTRACTS_LIST.count" 
      class="w-100"
      :params="filter"
      @refresh="onFiltered('pagination')"
      :page="filter.page"
      :page_size="filter.page_size"
      />

    <seeProductsModal :seeProducts="seeProducts"></seeProductsModal>
  </div>
</template>

<script>
import { BButton, BTable, BBadge, VBTooltip, BCard, BFormGroup, BRow, BCol, BFormCheckbox } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import areYouSure from "@/mixins/areYouSure";
import Pagination from "@/components/Pagination.vue";
import check from "@/mixins/check";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";
import seeProductsModal from "./components/modals/seeProductsModal.vue";
import addQueryToCurrentPage from "@/mixins/addQueryToCurrentPage";


import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import VueDataPicker from '@/components/VueDatePicker.vue'
import AppSearchInput from '@/components/AppSearchInput.vue'
import disableButton from "@/mixins/disableButton"

export default {
  components: {
    BButton,
    Pagination,
    BTable,
    BCard,
    BBadge,
    Loader,
    seeProductsModal,

    vSelect,
    BFormGroup,
    BRow,
    BCol,
    AppSearchInput,
    VueDataPicker,
    BFormCheckbox,
  },
  mixins: [areYouSure, check, priceFormatMixin, loader, addQueryToCurrentPage, disableButton],
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "date",
          key: "created_at",
          thClass: "tableHeadClass",
        },
        {
          label: "number",
          key: "contract_number",
          thClass: "tableHeadClass",
        },
        {
          label: "provider",
          key: "seller.company_name",
          thClass: "tableHeadClass text-center",
        },
        {
          label: "product",
          key: "instruments_goods",
          thClass: "tableHeadClass text-center",
        },
        {
          label: "sum",
          key: "amount",
          thClass: "tableHeadClass",
        },
        {
          label: "status",
          key: "status",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
      filter: {
        search: "",
        seller: "",
        status: "",
        all: null,
        page_size: 10,
        page: 1,
        is_old: false,
      },
      seeProducts: [],
      dateFilter: {
        start_date: "",
        end_date: "",
      },
    };
  },
  computed: {
    ...mapGetters("agrements", ["GET_CONTRACTS_LIST"]),
    ...mapGetters('contacts', ['GET_CONTACTS_TABLE_LIST']),
    ...mapGetters('application', ['GET_APPLICATION_STATUS']),

    contects() {
      if (Array.isArray(this.GET_CONTACTS_TABLE_LIST)) return this.GET_CONTACTS_TABLE_LIST
      return []
    },
  },
  async mounted() {
    this.isLoading = true;


    await this.FETCH_ALL_CONTACTS_LIST({ mini: 1, type: "provider"  });
    await this.FETCH_APPLICATION_STATUS({ content_type_model: 'contract' });



    await this.FETCH_CONTRACTS_LIST({
      page: this.$route.query.page ? this.$route.query.page : 1,
      page_size: this.$route.query.page_size ? this.$route.query.page_size : 10,

      status: this.$route.query.status ? this.$route.query.status : "",
      search: this.$route.query.search ? this.$route.query.search : "",
      seller: this.$route.query.seller ? this.$route.query.seller : "",

      start_date: this.$route.query.start_date ? this.$route.query.start_date : "",
      end_date: this.$route.query.end_date ? this.$route.query.end_date : "",
      is_old: this.$route.query.is_old ? this.$route.query.is_old : false,
    });


    let status = this.GET_APPLICATION_STATUS.results.find((elem) => elem.id == this.$route.query.status)
    if(status){
      this.filter.status = {id: status.id, name: status.name}
    }
   
    let seller = this.GET_CONTACTS_TABLE_LIST.find((elem) => elem.id == this.$route.query.seller)
    if(seller){
      this.filter.seller = {id: seller?.id, title: seller?.title}
    }


    // this.filter.status = this.$route.query.status ? this.$route.query.status : "";
    this.filter.search = this.$route.query.search ? this.$route.query.search : "";
    this.dateFilter.start_date = this.$route.query.start_date ? this.$route.query.start_date : "";
    this.dateFilter.end_date = this.$route.query.end_date ? this.$route.query.end_date : "";
    this.filter.page_size = this.$route.query.page_size ? this.$route.query.page_size : 10;
    this.filter.is_old = this.$route.query.is_old ? this.$route.query.is_old : false;

    setTimeout(() => {
      this.filter.page = this.$route.query.page ? this.$route.query.page : 1;
    }, 0)




    this.isLoading = false;
  },
  methods: {
    ...mapActions("contacts", ["FETCH_ALL_CONTACTS_LIST"]),
    ...mapActions("agrements", [
      "FETCH_CONTRACTS_LIST",
      "DELETE_CONTRACTS_LIST",
      "UPDATE_CONTRACTS_LIST",
      "UPDATE_PATCH_CONTRACTS_LIST",
    ]),
    ...mapActions('application', ['FETCH_APPLICATION_STATUS']),

 
    
    // deleteContract(id) {
    //   this.$_showAreYouSureModal().then((success) => {
    //     if (!success) return;
    //     this.DELETE_CONTRACTS_LIST(id)
    //       .then(() => {
    //         this.FETCH_CONTRACTS_LIST(this.params);
    //         this.$_okToast("Success");
    //       })
    //       .catch(() => {
    //         this.$_errToast("Error");
    //       });
    //   });
    // },





    async onFiltered(text) {
      this.isLoading = true;

      if(text != 'pagination'){
        this.filter.page = 1;
      }

      let filter = this.filter
      if(this.filter.status || (this.filter.status && this.filter.status.id)){
        if(this.filter.status == 'all'){
          filter.status = ''
          filter.all = true
        } else {
          filter.status = typeof this.filter.status == "number" ? this.filter.status : this.filter.status.id
          filter.all = null
        }
      }
      if(this.filter.seller || (this.filter.seller && this.filter.seller.id)){
        filter.seller = typeof this.filter.seller == "number" ? this.filter.seller : this.filter.seller.id
      }


      let response = await this.FETCH_CONTRACTS_LIST({
        ...filter,
        ...this.dateFilter,
      });
      
      this.$_addParamsToLocation({ ...filter, ...this.dateFilter })



      if (
        response &&
        response.response &&
        response.response.data.detail == "Invalid page."
      ) {
        this.dateFilter.start_date = "";
        this.dateFilter.end_date = "";

        await this.FETCH_CONTRACTS_LIST({ ...filter, ...this.dateFilter });
        this.$_addParamsToLocation({ ...filter, ...this.dateFilter })
      }

      this.isLoading = false;
    },



    
    async search(text) {
      this.isLoading = true;

      this.filter.page = 1;
      this.filter.search = text;

      let filter = this.filter
      if(this.filter.status || (this.filter.status && this.filter.status.id)){
        filter.status = typeof this.filter.status == "number" ? this.filter.status : this.filter.status.id
      }
      if(this.filter.seller || (this.filter.seller && this.filter.seller.id)){
        filter.seller = typeof this.filter.seller == "number" ? this.filter.seller : this.filter.seller.id
      }
      

      let response = await this.FETCH_CONTRACTS_LIST({
        ...filter,
        ...this.dateFilter,
      });
      

      this.$_addParamsToLocation({ ...filter, ...this.dateFilter })



      if (
        response &&
        response.response &&
        response.response.data.detail == "Invalid page."
      ) {
        this.dateFilter.start_date = "";
        this.dateFilter.end_date = "";

        await this.FETCH_CONTRACTS_LIST({ ...filter, ...this.dateFilter });
        this.$_addParamsToLocation({ ...filter, ...this.dateFilter })
      }

      this.isLoading = false;
      // this.$set(this.filter, 'search', e)
      // this.refresh()
    },



  




    async dateInput(e) {
      this.isLoading = true;

      this.filter.page = 1;

      let filter = this.filter
      if(this.filter.status || (this.filter.status && this.filter.status.id)){
        filter.status = typeof this.filter.status == "number" ? this.filter.status : this.filter.status.id
      }
      if(this.filter.seller || (this.filter.seller && this.filter.seller.id)){
        filter.seller = typeof this.filter.seller == "number" ? this.filter.seller : this.filter.seller.id
      }
      

      let response = null
      if (e) {
        this.dateFilter.start_date = e.start;
        this.dateFilter.end_date = e.end;
        response = await this.FETCH_CONTRACTS_LIST({
          ...filter,
          ...this.dateFilter,
        });
      } else {
        response = await this.FETCH_CONTRACTS_LIST({ ...filter });
      }
      
      this.$_addParamsToLocation({ ...filter, ...this.filter })
      


      if (
        response &&
        response.response &&
        response.response.data.detail == "Invalid page."
      ) {
        this.dateFilter.start_date = "";
        this.dateFilter.end_date = "";

        await this.FETCH_CONTRACTS_LIST({ ...filter, ...this.dateFilter });
        this.$_addParamsToLocation({ ...filter, ...this.dateFilter })
      }

      this.isLoading = false;
    },







    openSeeProductsModal(value){
      console.log(value)
      this.seeProducts = value
      this.$bvModal.show("seeProductsModal");
    },
    onChangeStatus(props, item) {
      const status = {
        denied_contract: this.$t('switch_to_denied_status'),
        paid_contract: this.$t('switch_to_paid_status'),
        awaiting_contract: this.$t('switch_to_pending_payment_status'),
        close_contract: this.$t('go_to_completed_status'),
      };
      this.$bvModal
        .msgBoxConfirm(
          this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t("attention"),
            size: "sm",
            okVariant: item.color,
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("no"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (!value) return;
          this.UPDATE_PATCH_CONTRACTS_LIST({
            data: {
              status_unique: item.unique_name,
              id: props.item.id,
            },
            id: props.id,
          })
            .then(() => {
              this.FETCH_CONTRACTS_LIST(this.filter);
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },
  },





};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

.dark-layout #user-table .tableRowClass {
  background: #19213a;
}

.dark-layout .dark {
  background-color: #283046 !important;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}



@import "@core/scss/vue/libs/vue-select.scss";

.dark-layout input.form-control[readonly=readonly]{
background-color: #283046 !important;
opacity: 1 !important;
}
</style>
